<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Would you like to give:">
            <DonationFrequency />
          </FormSection>
          <FormSection title="How much would you like to give:">
            <AmountSelector />
            <ErrorLabel field="amount" />
            <TransactionFee />
          </FormSection>
          <FormSection title="">
            <div style="margin-bottom: 7px; font-size: 18px">
              Which campus would you like your donation to go to?
            </div>
            <FormRow inline>
              <FormCol field="applications.0.department" width="half" :showLabel="false">
                <FormSelect>
                  <option value="JLIC_BarIlan">Bar Ilan</option>
                  <option value="JLIC_Binghamton">Binghamton</option>
                  <option value="JLIC_Brandeis">Brandeis</option>
                  <option value="JLIC_BrooklynCollege">Brooklyn</option>
                  <option value="JLIC_CSUN">CSUN</option>
                  <option value="JLIC_Columbia">Columbia/Barnard</option>
                  <option value="JLIC_Cornell">Cornell</option>
                  <option value="JLIC_Atlanta">Greater Atlanta</option>
                  <!-- <option value="Greater Toronto">Greater Toronto</option> -->
                  <option value="JLIC_IDCHerzliya">IDC- Herzliya</option>
                  <option value="JLIC_JohnsHopkins">Johns Hopkins</option>
                  <option value="JLIC_MachonLev">Machon Lev</option>
                  <option value="JLIC_McMaster">McMaster</option>
                  <option value="JLIC_Michigan">Michigan</option>
                  <option value="JLIC_NYU">NYU</option>
                  <option value="JLIC_Jerusalem">OU JLIC Jerusalem</option>
                  <option value="JLIC_TLV">OU JLIC TLV</option>
                  <option value="JLIC_Princeton">Princeton</option>
                  <option value="JLIC_Queens">Queens</option>
                  <option value="JLIC_Rutgers">Rutgers</option>
                  <option value="JLIC_SMC">SMC</option>
                  <option value="JLIC_Technion">Technion</option>
                  <option value="JLIC_TAU">MD Katz OU-JLIC at Tel Aviv University</option>
                  <option value="JLIC_UCLA">UCLA</option>
                  <option value="JLIC_Chicago">UChicago</option>
                  <option value="JLIC_Uillinois">University of Illinois</option>
                  <option value="JLIC_UMD">UMD</option>
                  <option value="JLIC_UMASS">UMass</option>
                  <option value="JLIC_Penn">Penn</option>
                  <option value="JLIC_WashingtonUniversity">Washington University</option>
                  <option value="JLIC_Western">Western</option>
                  <option value="JLIC_Yale">Yale</option>
                </FormSelect>
              </FormCol>
            </FormRow>
          </FormSection>
          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow> 
            <br />
            <InHonorOf />
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
</style>
